export function Skeleton({ height = 16 }: { height?: number }): JSX.Element {
  return (
    <div
      role="status"
      aria-label="Loading"
      style={{
        height,
        background: '#eee',
        borderRadius: 4,
        animation: 'pulse 1.2s infinite',
      }}
    />
  );
}
